import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Config } from 'datatables.net';
import { forkJoin, Subject } from 'rxjs';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { FormModalComponent } from '../../modal/form-modal/form-modal.component';
import { environment } from 'src/environments/environment';
import { unitList } from 'src/assets/config/constants';
import { ToastrService } from 'ngx-toastr';
import { ActionType, ITable, TableRequest } from 'src/app/model/table.model';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AuthServiceUser } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-product-list',
    templateUrl: './product-list.component.html',
    styleUrl: './product-list.component.css',
    standalone: false
})
export class ProductListComponent implements OnInit {
  actionType = ActionType;
  showLoader: boolean = false;
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  dtOptions: Config = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild('itemDeleteModal') itemDeleteModal!: any;
  columnList = [];

  tableData = [];

  pageInfo: TableRequest = {
    pageSize: 10,
    currentPage: 1,
    totalCount: 0,
    filteredValue: [],
    searchValue: '',
    sortColumn: '',
    sortOrder: 'asc'
  }

  actionItems: ActionType[] = [];
  filterFields = [];
  selectedDeleteItem = ""

  actionEvent(data) {
    const currentUser = this.authService.getUserInfo();
    let productId = data.value._id;
    let filteredZoneId = this.pageInfo.filteredValue?.find(item => item['zone']);
    if (currentUser.role?.includes('zoneadmin') || filteredZoneId) {
      productId = data.value.product;
    }
    if (data.type == this.actionType.UPDATE) {
      this.editItem(productId);
    }
    if (data.type == this.actionType.DELETE) {
      const rawName = this.getLocalizedText(data.value.name) || (typeof data.value.name === 'string' ? data.value.name : '');
      this.selectedDeleteItem = this.stripHtml(rawName);
      this.deleteItemCheck(this.itemDeleteModal, productId);
    }
  }

  pageInfoChange(data) {
    this.pageInfo = data;
    this.getProducts();
  }

  filteredValue() {
    // console.log(this.selectedFilters());
  }

  // Method to filter options in each field based on filter text
  filterOptions(field: any) {
    return field.options;
  }


  closeResult = '';
  eachData: any = {
    discorselling: 'disc'
  };
  rows: any;
  unitList: any = unitList;
  mainCategoryList: any = [];
  categoryList: any = [];
  subCategoryList: any = [];
  dropdownSettings: any = {};
  dropdownSettingsTags: any = {};
  previewImages: any = [];
  uploadedFiles: Array<File>;
  showDiscount: boolean = true;
  showSelling: boolean = false;
  tagsList: any = [];
  tagData: any = {};
  imageUrls: any = [
    {
      image: ""
    }
  ];



  constructor(private route: ActivatedRoute, public authService: AuthServiceUser, public loader: LoadingBarService, private apiService: ApiServiceListService, private router: Router, private modalService: NgbModal, private toastr: ToastrService) { }

  currentModuleName = this.route.snapshot.data['module'];
  ngOnInit() {
    this.getTagsList();
    this.breadcrumb = {
      'mainlabel': 'Product Management',
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      searching: true,
      //  paging:false
      lengthChange: true,
      language: {
        searchPlaceholder: 'search products'
      }
    }
    this.dropdownSettings = {
      singleSelection: true,
      idField: '_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };
    this.dropdownSettingsTags = {
      singleSelection: false,
      idField: '_id',
      textField: 'name',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true
    };
    // this.getProducts();
    this.getProductFullDetails();
  }

  private getLocalizedText(value: any): string {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return value.en || value.te || '';
    }
    return typeof value === 'string' ? value : '';
  }

  private stripHtml(value: string): string {
    return value.replace(/<[^>]*>/g, '').trim();
  }

  private normalizeTableValue(value: any): any {
    if (value == null) {
      return value;
    }

    if (Array.isArray(value)) {
      return value
        .map(item => this.normalizeTableValue(item))
        .filter(Boolean)
        .join(', ');
    }

    if (typeof value === 'object') {
      if ('en' in value || 'te' in value) {
        return this.getLocalizedText(value);
      }
      if ('name' in value) {
        return this.getLocalizedText(value.name);
      }
    }

    return value;
  }

  private normalizeTableRow(item: any): any {
    const normalizedRow = { ...item };
    Object.keys(normalizedRow).forEach((key) => {
      if (key === '_id' || key === 'product') {
        return;
      }
      normalizedRow[key] = this.normalizeTableValue(normalizedRow[key]);
    });
    return normalizedRow;
  }

  private normalizeFilterFields(fields: any[] = []): any[] {
    return fields.map(field => ({
      ...field,
      options: Array.isArray(field.options)
        ? field.options.map((option: any) => {
          if (option && typeof option === 'object' && 'name' in option) {
            return { ...option, name: this.getLocalizedText(option.name) || option.name };
          }
          return option;
        })
        : field.options,
    }));
  }

  editItem(id: string) {
    this.router.navigateByUrl('/product/update/' + id);
  }

  discountOrSelling() {
    if (this.eachData.discorselling == 'disc') {
      this.showDiscount = true;
      this.showSelling = false;
      this.getMainCategory();
    } else {
      this.showDiscount = false;
      this.showSelling = true;
    }
  }

  moveToAdd() {
    this.router.navigateByUrl('/product/create');
  }

  moveToRakeemart() {
    this.router.navigateByUrl('/rakeemart-product/create');
  }

  getProductFullDetails() {
    const productInfo$ = this.apiService.getProductFilterList();
    const getProducts$ = this.apiService.getProductList({ body: this.pageInfo });

    // Combine both observables
    forkJoin([productInfo$, getProducts$]).subscribe(
      {
        next: ([prodcutInfo, productData]) => {
          // Both results are now available
          // this.combinedResult = { userDetails, userOrders };
          // const product = prodcutInfo;
          if (prodcutInfo) {
            this.filterFields = this.normalizeFilterFields(prodcutInfo.data.filterFields);
            this.actionItems = prodcutInfo.data.actionItems;
            this.columnList = prodcutInfo.data.columnList;
          }
          if (productData) {
            this.tableData = productData.data.tableData.map((item) => {
              const normalizedItem = this.normalizeTableRow(item);
              if (typeof normalizedItem.barcode === 'string' && normalizedItem.barcode.startsWith('RKMRT')) {
                normalizedItem.name = '<div class="mw-200"><img src="/assets/images/circle-r.svg" alt="(RKMRT)" class="rakee-icon"> ' + normalizedItem.name + '</div>';
              }
              return normalizedItem;
            });
            this.pageInfo.totalCount = productData.data.pageInfo.totalCount;
          }
          this.loader.complete();
        },
        error: (error) => {
          console.error('Error:', error);
        }
      }
    );
  }
  getProductFilterList() {
    this.apiService.getProductFilterList().subscribe({
      next: (value) => {
        console.log(value.data);
        if (value.data) {
          this.filterFields = this.normalizeFilterFields(value.data.filterFields);
          this.actionItems = value.data.actionItems;
          this.columnList = value.data.columnList;

          this.getProducts();
        }

      }
    })
  }

  getProducts() {
    let parameter: any = {
      body: this.pageInfo
    }
    this.loader.increment(35);
    this.apiService.getProductList(parameter).subscribe({
      next: (value: ITable) => {
        // Handle emitted values
        console.log(value.data);
        if (value.data.tableData) {

          this.tableData = value.data.tableData.map((item) => {
            const normalizedItem = this.normalizeTableRow(item);
            if (typeof normalizedItem.barcode === 'string' && normalizedItem.barcode.startsWith('RKMRT')) {
              normalizedItem.name = '<div class="mw-200"><img src="/assets/images/circle-r.svg" alt="(RKMRT)" class="rakee-icon"> ' + normalizedItem.name + '</div>';
            }
            return normalizedItem;
          });
          this.pageInfo.totalCount = value.data.pageInfo.totalCount;

        } else {
          this.tableData = [];
          this.pageInfo.totalCount = 0;
        }

      },
      error: (error: any) => {
        // Handle errors
      },
      complete: () => {
        this.loader.complete();
      }
    });
  }

  getTagsList() {
    let parameter: any = {
      methodType: "GET",
    }
    this.apiService.getTagsList(parameter).subscribe(
      {
        next: (response: any) => {
          // console.log(response.data);
          // this.tagsList = response.data;
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            this.tagsList.push({ _id: element.name, name: element.name });
          }
          // console.log(this.tagsList);
        },
        error: (err) => {
          console.log(err);

        }
      }
    );
  }

  openTagModal(openTag) {
    let self = this;


    self.modalService.open(openTag, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'lg', centered: true }).result.then((result) => {
      console.log("self.selectObj", result);
      if (result == 'Save Click') {
        self.saveTag();
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }


    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  saveTag() {
    let parameter: any = {
      methodType: "POST",
    }
    this.apiService.saveTags(parameter, this.tagData).subscribe(
      {
        next: (response: any) => {
          this.getTagsList();
          // modal.dismiss();
          this.closeResult = `Dismissed ${this.getDismissReason('Submitted successfully')}`;
        },
        error: (err) => {
          console.log(err);

        }
      }
    );
  }

  updateTags(tags, type) {
    let tempTag = [];
    if (type == 'select') {
      tempTag = tags;
    } else {
      for (let i = 0; i < tags.length; i++) {
        const element = tags[i];
        tempTag.push({ _id: element, name: element });
      }
    }
    this.eachData.selectedTag = [];
    this.eachData.selectedTag = tempTag;
  }

  private getDismissReason(reason: any): string {
    console.log(reason);

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getMainCategory() {
    let parameter: any = {
      methodType: "GET",
    }
    this.apiService.getMainCategoryList(parameter).subscribe({
      next: (response: any) => {
        this.mainCategoryList = response.data;
        // this.eachData.mainCategory = 
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {
        console.log("Comple");

      }
    });
  }

  getCategory() {
    let parameter: any = {
      methodType: "POST",
    }
    let body: any = {};
    // console.log(this.eachData.mainCategory);
    body.mainCategory = this.eachData.mainCategory;
    this.apiService.getCategoryList(parameter, body).subscribe({
      next: (response: any) => {
        this.categoryList = response.data;
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {

      }
    });
  }

  getSubCategory() {
    let parameter: any = {
      methodType: "POST",
    }
    let body: any = {};

    body.category = this.eachData.category;
    this.apiService.getSubCategoryList(parameter, body).subscribe({
      next: (response: any) => {
        this.subCategoryList = response.data;
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {

      }
    });
  }

  updateDrpdown(type) {
    if (type == 'main') {
      this.getCategory();
    } else if (type == 'cate') {
      this.getSubCategory();
    }
  }

  fileChange(ev) {

    if ((ev.target.files.length + this.previewImages.length) > 4) {
      alert("Please select max 4 files.");
      // e.preventDefault();
    } else {
      console.log(this.uploadedFiles);
      if (this.uploadedFiles != undefined) {

        this.uploadedFiles = [...this.uploadedFiles, ...ev.target.files];
      } else {
        this.uploadedFiles = ev.target.files;
      }

      for (let i = 0; i < ev.target.files.length; i++) {
        const element = ev.target.files[i];
        let reader = new FileReader();

        reader.readAsDataURL(element);
        reader.onload = (evn: any) => {
          // To get image dimensions
          const img = new Image();
          img.src = window.URL.createObjectURL(element);

          let interval = setInterval(() => {
            if (img.height != 0 && img.width != 0) {
              console.log(img.height);
              this.previewImages.push({
                height: img.height,
                width: img.width,
                url: evn.target.result
              });
              console.log(this.previewImages);
              clearInterval(interval);
            }
          }, 1000);
        }
      }


    }
  }

  openModal(OpenShowModelContent, item: any) {
    let self = this;
    this.eachData = { ...item };
    this.getMainCategory();
    this.getCategory();
    this.getSubCategory();
    let tempTag = [];
    for (let i = 0; i < item.tags.length; i++) {
      const element = item.tags[i];
      tempTag.push({ _id: element, name: element });
    }
    this.eachData.selectedTag = tempTag;
    // this.eachData.mainCategory[0] = this.eachData.mainCategory;
    console.log(this.eachData);
    // this.getCategory(item);
    // this.getProductById(item._id);

    // this.eachData.category = [{ name: "Fresh Fruits" }];
    this.eachData.unitList = 1;
    self.modalService.open(OpenShowModelContent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'lg', centered: true }).result.then((result) => {
      // console.log("self.selectObj", result);
      if (result == 'Save Click') {
        self.updateRecord(this.eachData);
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }


    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  updateRecord(valid) {
    if (valid) {
      // this.modalService.dismissAll();
      let parameter: any = {
        methodType: "PUT",
      }
      let body = this.eachData;
      body.isFeatureProduct = {
        active: body.featured,
        rank: 0
      }
      body.category = this.eachData.category[0];
      body.mainCategory = this.eachData.mainCategory[0];
      console.log(body);
      return;

      this.apiService.updateProduct(parameter, body).subscribe((response: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason('Submitted successfully')}`;

      }, (error) => {

      });
    }
  }


  deleteItemCheck(deleteModal: any, id) {
    let self = this;

    self.modalService.open(deleteModal, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'sm', centered: true }).result.then((result) => {
      console.log("self.selectObj", result);
      if (result == 'Ok click') {
        this.deleteItem(id);
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }
    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  deleteItem(id) {
    let body: any = {};
    body = { _id: id }
    console.log('DDDDDD', body);

    // return;
    this.apiService.deleteProductAPI(body).subscribe((response: any) => {
      console.log(response);
      if (response.success) {
        this.toastr.success(response.message, '', {
          timeOut: 3000,
        });
        this.getProducts();
      } else {
        const errorText = [response?.message, response?.error].filter(Boolean).join(' - ');
        this.toastr.error(errorText || 'Delete product failed', '', {
          timeOut: 3000,
        });
      }
    }, (error) => {
      const apiError = error?.error || {};
      const errorText = [apiError?.message, apiError?.error, error?.message].filter(Boolean).join(' - ');
      this.toastr.error(errorText || 'Delete product failed', '', {
        timeOut: 3000,
      });
    });
  }

  LoadInvoice() {
    // this.service.GetAllInvoice().subscribe(res => {
    //   this.Invoiceheader = res;
    //   this.dtTrigger.next(null);
    // });
  }

  // invoiceremove(invoiceno: any) {
  //   if (confirm('Do you want to remove this Invoice :' + invoiceno)) {
  //     this.service.RemoveInvoice(invoiceno).subscribe(res => {
  //       let result: any;
  //       result = res;
  //       if (result.result == 'pass') {
  //         this.alert.success('Removed Successfully.', 'Remove Invoice')
  //         this.LoadInvoice();
  //       } else {
  //         this.alert.error('Failed to Remove.', 'Invoice');
  //       }
  //     });
  //   }
  // }
  PrintInvoice(invoiceno: any) {
    // this.service.GenerateInvoicePDF(invoiceno).subscribe(res => {
    //   let blob: Blob = res.body as Blob;
    //   let url = window.URL.createObjectURL(blob);
    //   window.open(url);
    // });
  }
  DownloadInvoice(invoiceno: any) {
    // this.service.GenerateInvoicePDF(invoiceno).subscribe(res => {
    //   let blob: Blob = res.body as Blob;
    //   let url = window.URL.createObjectURL(blob);

    //   let a = document.createElement('a');
    //   a.download = invoiceno;
    //   a.href = url;
    //   a.click();

    // });
  }

  PreviewInvoice(invoiceno: any) {
    // this.invoiceno = invoiceno;
    // this.service.GenerateInvoicePDF(invoiceno).subscribe(res => {
    //   let blob: Blob = res.body as Blob;
    //   let url = window.URL.createObjectURL(blob);
    //   this.pdfurl = url;
    //   this.modalservice.open(this.popupview, { size: 'lg' });
    //   //window.open(url);
    // });
  }
}
